module.exports = __webpack_public_path__ + "img/glass-opacitymap.68d7ebad.png";